export default __webpack_public_path__ + "static/media/towel.43bf975f.svg";